import React from "react"

import { HintedLabel } from "../../../components/FieldHint.tsx"

type Translate = (key: string, options?: Record<string, unknown>) => string

export type InvoiceColumnConcept = "origin" | "paidToDate" | "status"

/**
 * Both invoice tables carry these three columns, and each names a concept
 * rather than a value, so the explanation is built once and cannot drift
 * between the two.
 */
export const invoiceColumnTitle = (
  t: Translate,
  concept: InvoiceColumnConcept
) => (
  <HintedLabel
    hint={t(`invoices.columns.${concept}Hint`)}
    field={t(`invoices.columns.${concept}`)}
    // The specs run without i18n, so every hint's accessible name is the bare key.
    testId={`invoice-hint-${concept}`}
  />
)
